module.exports = __webpack_public_path__ + "static/img/kerrisk-xavier.61e9151.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kerrisk-xavier.jpg
// module id = FQXP
// module chunks = 0